import { ReactNode } from "react";

import styles from "./HomeLayout.module.css";
import Aside from "./Aside";
import RightSidebar from "./RightSidebar";

const HomeLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <Aside />
        <div className={styles.mainAndRightArea}>
          {children}
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};
export default HomeLayout;
